import React, { PureComponent } from 'react';
import Select from 'react-select';

class ApplicationsToHighlight extends PureComponent {

  filterFn = (d) => {
    return (
      (!this.props.selectedAssignmentStatus || d.assigned1stChoice === this.props.selectedAssignmentStatus.value) &&
      (!this.props.selectedEnrollmentStatus || d.enrolledStatus === this.props.selectedEnrollmentStatus.value) &&
      (!this.props.selectedCTIPStatus || d.ctip === this.props.selectedCTIPStatus.value) &&
      (!this.props.selectedZip || d.zip === this.props.selectedZip.value) &&
      (!this.props.selectedSchool || d.schools[0] === this.props.selectedSchool.value)
    );
  }

  render() {
    if (this.props.applications.length === 0) return null;
    const filterApplied = [
      this.props.selectedAssignmentStatus,
      this.props.selectedEnrollmentStatus,
      this.props.selectedCTIPStatus,
      this.props.selectedZip,
      this.props.selectedSchool
    ].some(d => d !== null && d.value);

    const filteredApplications = this.props.applications.filter(d => this.props.browsableIDs.has(d.id) && this.filterFn(d));

    const filteredZipCodes = new Set(filteredApplications.map(d => d.zip));
    const filteredCTIPStatuses = new Set(filteredApplications.map(d => d.ctip));
    const filteredSchoolCodes = new Set(filteredApplications.map(d => d.schools[0]));
    const filteredAssignmentStatuses = new Set(filteredApplications.map(d => d.assigned1stChoice));
    const filteredEnrollmentStatuses = new Set(filteredApplications.map(d => d.enrolledStatus));

    const sameValueAndLabel = d => ({ value: d, label: d });
    const zipCodeOptions = [...filteredZipCodes].sort().map(sameValueAndLabel);
    const CTIPStatusOptions = [...filteredCTIPStatuses].sort().map(sameValueAndLabel);
    const schoolCodeOptions = [...filteredSchoolCodes].sort((a, b) => {
      const aName = this.props.schoolCodes.get(a).name;
      const bName = this.props.schoolCodes.get(b).name;
      if (aName < bName) return -1;
      if (aName > bName) return 1;
      return 0;
    }).map((code) => {
      return { value: code, label: this.props.schoolCodes.get(code).name };
    });
    const assignmentStatusOptions = [...filteredAssignmentStatuses].sort().map(sameValueAndLabel);
    const enrollmentStatusOptions = [...filteredEnrollmentStatuses].sort().map(sameValueAndLabel);

    const selectStyles = {
      control: (base, _state) => ({ ...base, minHeight: '25px', height: '25px' }),
      valueContainer: (base, _state) => ({ ...base, minHeight: '25px', height: '25px' }),
      input: (base, _state) => ({ ...base, padding: 0 }),
      clearIndicator: (base, _state) => ({ ...base, padding: 0 }),
      dropdownIndicator: (base, _state) => ({ ...base, padding: '2px' }),
      indicatorSeparator: (base, _state) => ({ ...base, width: 0 })
    };

    return (
      <div>
        <div className="controls-heading">
          <h2>Search for applications</h2> {filterApplied && <span id="clear-all" onClick={this.props.resetControls}>Clear all</span>}
        </div>
        <div>
          <form className="grid">
            <label className="grid-label" htmlFor="select-zip">Zip code:</label>
            <Select className="grid-item" id="select-zip" options={zipCodeOptions} styles={selectStyles} value={this.props.selectedZip} isClearable={true} autoFocus={true}
              onChange={(option) => this.props.onDropdownChange("selectedZip", option)} />
            <label className="grid-label" htmlFor="select-ctip">From CTIP1 area?</label>
            <Select className="grid-item" id="select-ctip" options={CTIPStatusOptions} styles={selectStyles} value={this.props.selectedCTIPStatus} isClearable={true}
              onChange={(option) => this.props.onDropdownChange("selectedCTIPStatus", option)} />
            <label className="grid-label" htmlFor="select-school">1st choice school:</label>
            <Select className="grid-item" id="select-school" options={schoolCodeOptions} styles={selectStyles} value={this.props.selectedSchool} isClearable={true}
              onChange={(option) => this.props.onDropdownChange("selectedSchool", option)} />
            <label className="grid-label" htmlFor="select-assignment">Got 1st choice?</label>
            <Select className="grid-item" id="select-assignment" options={assignmentStatusOptions} styles={selectStyles} value={this.props.selectedAssignmentStatus} isClearable={true}
              onChange={(option) => this.props.onDropdownChange("selectedAssignmentStatus", option)} />
            <label className="grid-label" htmlFor="select-enrollment">Where enrolled?</label>
            <Select className="grid-item" id="select-enrollment" options={enrollmentStatusOptions} styles={selectStyles} value={this.props.selectedEnrollmentStatus} isClearable={true}
              onChange={(option) => this.props.onDropdownChange("selectedEnrollmentStatus", option)} />
          </form>
        </div>
      </div>
    )
  }
}

export default ApplicationsToHighlight;



// WEBPACK FOOTER //
// ./src/ApplicationsToHighlight.js